export const lastItem = array => {
  if (!array?.length) return null
  return array[array.length - 1]
}
